import PropTypes from 'prop-types';

const RadioField = ({
  input,
  disabled,
  label,
  labelRequired,
  options,
  meta: { touched, error, warning, submitError },
  helpText,
  cssClass,
}) => {
  const { name, value, onChange } = input;

  const isChecked = (optionValue) => value === optionValue;

  if (!error) {
    error = submitError;
  }

  return (
    <fieldset className={`form-group radio${cssClass ? ' ' + cssClass : ''}${touched && error ? ' error' : ''}`}>
      {label && (
        <legend htmlFor={name}>
          {label}
          {labelRequired && <abbr title="Required">*</abbr>}
        </legend>
      )}
      {options.map((option, index) => (
        // eslint-disable-next-line @eslint-react/no-array-index-key
        <div key={index} className="radio">
          <input
            type="radio"
            id={`${name}-${index}`}
            name={name}
            value={option.value}
            onChange={onChange}
            disabled={disabled}
            checked={isChecked(option.value)}
          />
          <label htmlFor={`${name}-${index}`}>{option.label}</label>
        </div>
      ))}
      {helpText && <div className="text-info">{helpText}</div>}
      {touched && error && <div className="text-danger">{error}</div>}
      {touched && warning && !error && <div className="text-warning">{warning}</div>}
    </fieldset>
  );
};

RadioField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.string,
  options: PropTypes.array.isRequired,
  meta: PropTypes.object,
  helpText: PropTypes.string,
  cssClass: PropTypes.string,
};

export default RadioField;
